<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="formDataList" label-width="80px">
      <el-form-item label="买家账号:">
        <el-input
          size="small"
          v-model="formDataList.pin"
          placeholder="请输入买家账号"
          style="margin-right:40px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码:">
        <el-input
          size="small"
          v-model="formDataList.mobile"
          placeholder="请输入手机号码"
          style="margin-right:40px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input
          size="small"
          v-model="formDataList.remark"
          placeholder="备注"
          style="margin-right:40px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="提交时间">
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formDataList.orderStartTimeStart"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formDataList.orderStartTimeEnd"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px"
            class="time2"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()" style="margin-right:80px"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-button
        size="small"
        :disabled="tableLoding"
        class="search"
        plain
        @click="submitForm('formSearch')"
        style="margin:0 6px  0px 700px;font-size:14px"
        autofocus
      >
        <i
          class="el-icon-search"
          style="display:inline-block;width:14px;height:12px;font-size:14px"
        ></i> 查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm" plain style="margin: 0 auto;">重置</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formDataList: {
        pin: "", //买家账号
        mobile: "", //手机号码
        orderStartTimeStart: "", //提交时间开始
        orderStartTimeEnd: "", //提交时间结束
        remark: "", //备注
        bid: "",
      },

      tableLoding: false,
      city: "",
    };
  },
  methods: {
    clearTimeSendTime() {
      this.formDataList.orderStartTimeStart = "";
      this.formDataList.orderStartTimeEnd = "";
    },
    submitForm() {
      this.$emit("onSerach", this.formDataList);
    },
    resetForm() {
      this.formDataList = {
        pin: "",
        mobile: "",
        remark: "",
        orderStartTimeStart: "",
        orderStartTimeEnd: "",
      };
      this.$emit("onSerach", this.formDataList);
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
// }
.el-input,
.el-select {
  width: 280px;
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.btn_group {
  text-align: center;
}
</style>